<template>
  <div class="container left_side_item">
    <div class="row">
      <div class="content-slots" v-if="this.temperatures">
        <h6 class="text-start uppercased">სენსორის მონაცემები</h6>
        <transition name="fade" mode="out-in">
          <div class="table-content">
            <table class="table table-fixed number-data">
              <thead>
              <tr>
                <td @click.prevent="sortBy('trunc_60_minute')">
                  თარიღი
                  <template v-if="isFilteredBy('trunc_60_minute')">
                    <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
                  </template>
                </td>
                <td @click.prevent="sortBy('place.trunc_60_minute')">
                  დრო
                  <template v-if="isFilteredBy('place.trunc_60_minute')">
                    <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
                  </template>
                </td>
                <td @click.prevent="sortBy('tempo_average')">
                  <div>
                    <img src="/svgs/temp-green.svg" alt="">
                    <template v-if="isFilteredBy('tempo_average')">
                      <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
                    </template>
                  </div>
                </td>
                <th  @click.prevent="sortBy('humidity_average','sensor_data')">
                  <img src="/svgs/humidity-green.svg" alt="">
                  <template v-if="isFilteredBy('humidity_average')">
                    <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
                  </template>
                </th>
                <th  @click.prevent="sortBy('battery_average','sensor_data')">
                  <img src="/svgs/battery.svg" alt="">
                  <template v-if="isFilteredBy('battery_average')">
                    <font-awesome-icon :icon="['fa' ,getIconByOrdering()]" />
                  </template>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="temp in temperatures.data" v-bind:key="temp.id" @mouseover="onHover(temp)">
                <td>{{getDate(temp.trunc_60_minute)}}</td>
                <td>{{getTime(temp.trunc_60_minute)}}</td>
                <td style="font-family: var(--bs-body-font-family) !important;"> {{temp.tempo_average}} ℃ </td>
                <td class="font-roboto">
                  {{temp.humidity_average ? parseInt(temp.humidity_average)  : '--.--'}} %
                </td>
                <td class="font-roboto">
                  {{ temp.battery_average ?  parseInt(temp.battery_average) : '--.--'}} %
                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </transition>
      </div>
    </div>
  </div>


</template>

<script>
import moment from "moment";
import {ref} from "vue";

export default {
  name:'LeftSideReportsItem',
  computed:{
    temperatures(){
      return this.$store.state.warehouse.temperatureData.data
    }
  },
  methods:{
    isFilteredBy(key){
      if (this.filteringState.key === key){
        return true
      }
      return false
    },
    sortBy(key, nested = false){
      this.changeFilterState(key)

      let splitedKey = key.split('.')[key.split('.').length - 1]

      this.temperatures.data.sort((a,b)=>{
        let comparableA = a[splitedKey]
        let comparableB = b[splitedKey]

        if (nested){
          let path = nested.split('.')
          let tmpObj  = null
          let tmpObjB = null
          for (let i = 0 ; i < path.length; i++){
            if (i === 0){
              tmpObj = a[path[0]]
              tmpObjB = b[path[0]]
              continue
            }
            tmpObj = tmpObj[path[i]]
            tmpObjB = tmpObjB[path[i]]

          }
          if (tmpObj && tmpObjB){
            comparableA = tmpObj[splitedKey]
            comparableB = tmpObjB[splitedKey]
          }
        }

        if (this.filteringState.ordering === 'DESC'){
          return  comparableA > comparableB ? 1 : -1
        }else{
          return  comparableA < comparableB ? 1 : -1
        }
      })
    },
    changeFilterState(key){
      if (this.filteringState.key === key){
        this.filteringState.ordering = this.filteringState.ordering ===  'ASC' ? 'DESC' : 'ASC'
        return
      }
      this.filteringState.key = key
      this.filteringState.ordering = 'DESC'
    },
    getIconByOrdering(){
      let icon = 'sort-down'
      if (this.filteringState.ordering === 'DESC'){
        icon = 'sort-up'
      }
      return icon
    },
    getDate(dateString){
      return moment(dateString).format('DD/MM/YYYY')
    },
    getTime(dateString){
      return moment(dateString).format('HH:mm')
    },
    onHover(item){
      console.log(item,"item on hover")
      this.$parent.chartOptions = {...this.$parent.chartOptions, ...{
          xaxis: {
            labels: {
              style: {
                colors: ['red']
              }
            }
          }
        }
      }
    }
  },
  data(){
    return {
      loading:false,
      filteringState: ref({
        ordering: 'DESC',
        key: null
      })
    }
  }
}
</script>

<style scoped>

.content-slots table{
  width: 100%;
}


.content-slots .table-content{
  height: 84vh;
  padding-bottom: 0;
  overflow-x: hidden;
  overflow-y: auto;
  width: 100%;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.table-content::-webkit-scrollbar {
  display: none;
}

.content-slots .table-content table thead tr {
  position: sticky;
  background-color: #ffffff;
  top: 0;
}


.table, .table thead, .table thead tr,.table thead tr td, .table thead, .table tbody, .table tbody tr, .table tbody tr td{
  border: none !important;
}

.table tbody tr:last-child{
  border: transparent;
}

.table-fixed > tbody > tr > td:nth-child(1){
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
}
.table-fixed > tbody > tr > td:nth-child(5){
  border-bottom-right-radius: 5px;
  border-top-right-radius: 5px;
}

.table-fixed > tbody > tr:nth-child(2n+1) > td, .table-striped > tbody > tr:nth-child(2n+1) > th {
  background-color: var(--hover-item);
}


</style>